import { defineMessages } from 'react-intl';

export default defineMessages({
  cardTitle: {
    id: 'homeOnboardingSelfMifidSurvey.cardTitle',
    defaultMessage: 'Questionario MIFID',
  },
  maritalStatusPlaceholder: {
    id: 'homeOnboardingSelfMifidSurvey.maritalStatusPlaceholder',
    defaultMessage: 'Stato civile',
  },
  familyPlaceholder: {
    id: 'homeOnboardingSelfMifidSurvey.familyPlaceholder',
    defaultMessage: 'Nucleo familiare',
  },
  tileOfStudyPlaceholder: {
    id: 'homeOnboardingSelfMifidSurvey.tileOfStudyPlaceholder',
    defaultMessage: 'Titolo di studio',
  },
  employmentSectorPlaceholder: {
    id: 'homeOnboardingSelfMifidSurvey.employmentSectorPlaceholder',
    defaultMessage: 'Occupazione',
  },
  currentWorkPlaceholder: {
    id: 'homeOnboardingSelfMifidSurvey.currentWorkPlaceholder',
    defaultMessage: 'Scegli occupazione',
  },
  genericPlaceholder: {
    id: 'homeOnboardingSelfMifidSurvey.genericPlaceholder',
    defaultMessage: 'Scegli una risposta',
  },
  exitDialogDesc: {
    id: 'homeOnboardingSelfMifidSurvey.exitDialogDesc',
    defaultMessage:
      'Cliccando su “Esci” interromperai la compilazione del questionario e i dati non saranno salvati',
  },
  exitDialogExitBtn: {
    id: 'homeOnboardingSelfMifidSurvey.exitDialogExitBtn',
    defaultMessage: 'Esci',
  },
  mifidDialogDesc: {
    id: 'homeOnboardingSelfMifidSurvey.exitDialogDesc',
    defaultMessage:
      'Attenzione, hai modificato i seguenti campi che comportano la ricompilazione del questionario MiFID:',
  },
  mifidDialogExitBtn: {
    id: 'homeOnboardingSelfMifidSurvey.mifidDialogExitBtn',
    defaultMessage: 'No, torna indietro',
  },
  mifidDialogConfirmBtn: {
    id: 'homeOnboardingSelfMifidSurvey.exitDialogBackBtn',
    defaultMessage: 'Sì, sono sicuro',
  },
  exitDialogBackBtn: {
    id: 'homeOnboardingSelfMifidSurvey.exitDialogBackBtn',
    defaultMessage: 'Torna al questionario',
  },

  finishedMifidTitle: {
    id: 'homeOnboardingSelfMifidSurvey.toastSuccessMifidTitle',
    defaultMessage: 'Questionario MiFID completato',
  },
  finishedMifidDesc: {
    id: 'homeOnboardingSelfMifidSurvey.toastSuccessMifid',
    defaultMessage:
      'Gentile {customerName},\n la compilazione del questionario MiFID è avvenuta con successo.',
  },
  confirmButtonWebCollaboration: {
    id: 'homeOnboardingSelfMifidSurvey.confirmButtonWebCollaboration',
    defaultMessage: 'Conferma e chiudi chiamata',
  },
  mifidPfError: {
    id: 'homeOnboardingSelfMifidSurvey.mifidPfError',
    defaultMessage:
      'Le preferenze di sostenibilità espresse nella domanda 5.4 non sono coerenti con quelle manifestate nella domanda 5.2',
  },
  mifidGenericError: {
    id: 'homeOnboardingSelfMifidSurvey.mifidGenericError',
    defaultMessage:
      'La risposta fornita alla domanda {first} risulta incoerente con quella fornita alla domanda {others}.',
  },
});
